import { Component, OnInit } from '@angular/core';
import { ApiServiceService } from '../../services/common/api-service.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-merchant-leads',
  templateUrl: './merchant-leads.component.html',
  styleUrls: ['./merchant-leads.component.scss']
})
export class MerchantLeadsComponent implements OnInit {
  leads: any[] = [];
  loading: boolean = true;
  merchantId: string = '';

  constructor(private apiService: ApiServiceService) {}

  ngOnInit(): void {
    const merchantId = localStorage.getItem('merchantId');
    if (merchantId) {
      this.merchantId = merchantId;
      this.fetchLeads();
    } else {
      this.loading = false;
    }
  }

  fetchLeads(): void {
    this.apiService.getLeadsForMerchant(this.merchantId).subscribe({
      next: (res: any) => {
        this.leads = res.data || [];
        this.loading = false;
      },
      error: (err: any) => {
        console.error(err);
        this.loading = false;
      }
    });
  }
}
